import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "price-info__current" }
const _hoisted_2 = { class: "price-info__currency" }
const _hoisted_3 = {
  key: 0,
  class: "price-info__value"
}
const _hoisted_4 = { class: "price-info__value-euro" }
const _hoisted_5 = { class: "price-info__value-cent" }
const _hoisted_6 = {
  key: 1,
  class: "price-info__value"
}
const _hoisted_7 = { class: "price-info__value-euro" }
const _hoisted_8 = { class: "price-info__value-cent" }
const _hoisted_9 = {
  key: 2,
  class: "price-info__asterisk"
}
const _hoisted_10 = { class: "price-info__unit" }
const _hoisted_11 = { class: "price-info__unit-text" }
const _hoisted_12 = { class: "price-info__unit-price" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["price-info price-info--price-line-through", {
      'price-info--reduction': _ctx.value.old
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.value.currency), 1 /* TEXT */),
      _cache[2] || (_cache[2] = _createTextVNode()),
      (_ctx.value.old)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.splitValue[0]), 1 /* TEXT */),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.splitValue[1]), 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.splitValue[0]), 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.splitValue[1]), 1 /* TEXT */)
          ])),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (_ctx.showStar)
        ? (_openBlock(), _createElementBlock("sup", _hoisted_9, "\n        *\n      "))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getUnitText()), 1 /* TEXT */),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("span", _hoisted_12, [
        (_ctx.value.old)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.value.oldUnitPrice), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.value.unitPrice), 1 /* TEXT */)),
        _cache[4] || (_cache[4] = _createTextVNode()),
        (_ctx.value.unit)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "/" + _toDisplayString(_ctx.value.unit), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2 /* CLASS */))
}